// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__8Xduw","modal":"Modal_modal__fW9KX","slide-down":"Modal_slide-down__+Kx1L"};